import React from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";

const IntroClinic = () => {
  return (
    <div className="wrap main_wrap">
      <Header />
      <div className="intro_wrap">
        <div className="clinic_banner_box">
          <div
            className="clinic_banner animate__animated animate__slideInRight"
            style={{ animationDuration: "1.2s" }}
          ></div>
          <div
            className="banner_text_box animate__animated animate__slideInLeft"
            style={{ animationDuration: "1.5s" }}
          >
            <div className="banner_title">키움성장소개</div>
            <div className="banner_text">병원 둘러보기</div>
          </div>
        </div>
        <div
          className="clinic_box animate__animated animate__fadeIn"
          style={{ animationDuration: "1.5s" }}
        >
          <div className="clinic_img_container">
            {[...Array(parseInt(6))].map((data, index) => {
              return (
                <div className="clinic_img_cell">
                  <div className={`clinic_img img${index + 1}`}></div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default IntroClinic;
